<template>
  <div>
    <div v-if="loading" class="loading-bar">
      <atom-spinner
        :animation-duration="1000"
        :size="60"
        color="#ff1d5e"
        class="mx-auto"
      />
    </div>
    <div class="vx-row">
      <vx-card>
        <vs-table
          :max-items="paginationItems[1]"
          pagination
          :data="countrycurrencyData"
          :description="false"
          @selected="handleSelected"
          search
          :description-items="paginationItems"
          description-title="Registries"
          description-connector="of"
          description-body="Pages"
        >
          <template slot="header">
            <div class="list-heading">
              {{ $t("system.label.currencyExchange") }}
            </div>
            <div class="mr-2 mb-1 order-1">
              <vs-button
                icon-pack="feather"
                icon="icon-plus"
                @click="$router.push('/createCurrencyExchange').catch(() => {})"
                size="small"
                >{{ $t("system.label.createCurrencyExchange") }}</vs-button
              >
            </div>
          </template>
          <template slot="thead">
            <vs-th>{{ $t("system.label.id") }}</vs-th>
            <vs-th>{{ $t("system.label.baseCurrency") }}</vs-th>
            <vs-th>{{ $t("system.label.conversionCurrency") }}</vs-th>
            <vs-th>{{ $t("system.label.conversionRate") }}</vs-th>
            <vs-th>{{ $t("system.label.status") }}</vs-th>
            <vs-th>{{ $t("system.label.validFrom") }}</vs-th>
            <vs-th>{{ $t("system.label.validTo") }}</vs-th>
            <vs-th class="tHeadCenter">{{ $t("system.label.action") }}</vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr
              :key="index"
              :data="countrycurrencyData"
              v-for="(countrycurrencyData, index) in data"
            >
              <vs-td :data="countrycurrencyData.id">{{
                countrycurrencyData.id
              }}</vs-td>
              <vs-td :data="countrycurrencyData.baseCurrencyCode">{{
                countrycurrencyData.baseCurrencyCode
              }}</vs-td>
              <vs-td :data="countrycurrencyData.currencyCode">{{
                countrycurrencyData.currencyCode
              }}</vs-td>
              <vs-td :data="countrycurrencyData.conversionRate">{{
                countrycurrencyData.conversionRate
              }}</vs-td>
              <vs-td :data="countrycurrencyData.status">{{
                countrycurrencyData.status
              }}</vs-td>
              <vs-td :data="countrycurrencyData.validFrom">{{
                getDate(countrycurrencyData.validFrom)
              }}</vs-td>
              <vs-td :data="countrycurrencyData.validTo">{{
                getDate(countrycurrencyData.validTo)
              }}</vs-td>

              <vs-td class="whitespace-no-wrap">
                <div class="container_img">
                  <feather-icon
                    icon="EditIcon"
                    :title="$t('system.label.Edit')"
                    svgClasses="w-5 h-5 stroke-current cursor orange_icon"
                    @click.stop="editCurrencyExchange(countrycurrencyData.id)"
                    class="icon_row"
                  />
                  <feather-icon
                    icon="TrashIcon"
                    :title="$t('system.label.Delete')"
                    svgClasses="w-5 h-5 text-danger stroke-current cursor"
                    @click.stop="
                      deletePopup = true;
                      delId = countrycurrencyData.id;
                    "
                    class="icon_row"
                  />
                </div>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </vx-card>
    </div>
    <delete-popup
      :deletePopup="deletePopup"
      :title="$t('system.label.currencyExchange')"
      @deletePressed="deleteCurrencyData()"
      @cancelPressed="deletePopup = false"
    />
  </div>
</template>
<script>
import { mapGetters, mapState } from "vuex";
import moment from "moment";
import { AtomSpinner } from "epic-spinners";

export default {
  data() {
    return {
      loading: false,
      paginationItems: [5, 10, 15],
      deletePopup: false,
      delId: 0,
    };
  },
  components: {
    AtomSpinner,
  },
  computed: {
    ...mapState({
      formattedDate: (state) => state.settings.selectedDateFormat,
    }),
    ...mapGetters({
      countrycurrencyData: "currencyExchange/getCountryCurrencyList",
    }),
  },
  methods: {
    async deleteCurrencyData() {
      try {
        await this.$store.dispatch(
          "currencyExchange/deleteCountryCurrencyAction",
          this.delId
        );
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Successfully Deleted",
          type: "success",
        });
        this.getCurrencyList();
        this.deletePopup = false;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    getCurrencyList() {
      this.loading = true;
      try {
        this.$store.dispatch("currencyExchange/setCountryCurrencyData");
      } catch (e) {
        console.log("something went wrong", e);
      }
      this.loading = false;
    },
    handleSelected(countrycurrencyData) {
      this.$router.push({
        path: `/viewCurrencyExchange/${countrycurrencyData.id}`}).catch(() => {});
    },
    editCurrencyExchange(id) {
      this.$router.push(`/editCurrencyExchange/${id}`);
    },
    getDate(dateArray) {
      const date = new Date(dateArray[0], dateArray[1] - 1, dateArray[2]);
      const formattedDate = moment(date).format(this.formattedDate);
      return formattedDate;
    },
  },
  mounted() {
    this.getCurrencyList();
  },
};
</script>
<style lang="scss" scoped>
.vs-table--search {
  max-width: 100%;
  margin-left: 0px !important;
}

.vuesax-app-is-ltr .vs-table--search {
  margin-left: 0;
}

.vs-search-categeory {
  margin-top: 17px;
}
</style>
